import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';
import { companyInfo, businessAreas, companyStrengths } from '../../mocks/company';

export default function About() {
  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      
      {/* Hero Section */}
      <section className="relative h-96 flex items-center justify-center bg-gradient-to-r from-teal-600 to-teal-700">
        <div className="absolute inset-0 bg-black/20"></div>
        <div className="relative z-10 text-center text-white px-4">
          <h1 className="text-4xl md:text-5xl font-bold mb-4">회사소개</h1>
          <p className="text-lg md:text-xl text-white/90">
            하천정비 분야의 신뢰할 수 있는 파트너
          </p>
        </div>
      </section>

      {/* Company Overview */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
            <div>
              <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-6">
                우진에코텍주식회사
              </h2>
              <p className="text-base text-gray-600 mb-6 leading-relaxed">
                우진에코텍주식회사는 2003년 설립 이래 용접철망류 및 매트리스개비온 전문 제조기업으로서 하천정비 및 침식방지 구조물 분야에서 
                최고의 품질과 기술력을 인정받아 왔습니다.
              </p>
              <p className="text-base text-gray-600 mb-6 leading-relaxed">
                20년 이상의&nbsp; 제조 및 현장 경험을 바탕으로 전국 주요 하천정비 사업에 참여하며, 건설사, 토목회사, 지자체, 공공기관 등 
                다양한 고객사와 함께 성공적인 프로젝트를 수행해 왔습니다.
              </p>
              <p className="text-base text-gray-600 leading-relaxed">
                우리는 구조적 안정성과 현장 검증을 최우선으로 하며, 고객의 요구사항에 맞는 최적의 솔루션을 제공하기 위해 
                끊임없이 노력하고 있습니다.
              </p>
            </div>
            <div className="w-full h-96">
              <img 
                src="https://static.readdy.ai/image/de296e9d59e1469590f5774831dff4f2/37b55825d346fb805fc0a7ac3c085f71.jpeg" 
                alt="생산시설"
                className="w-full h-full object-cover rounded-lg shadow-lg"
              />
            </div>
          </div>
        </div>
      </section>

      {/* Company Info */}
      <section className="py-20 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <h2 className="text-3xl font-bold text-gray-900 mb-12 text-center">회사 정보</h2>
          <div className="bg-white rounded-lg shadow-sm p-8 md:p-12">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
              <div className="flex items-start">
                <div className="w-12 h-12 bg-teal-100 rounded-lg flex items-center justify-center mr-4 flex-shrink-0">
                  <i className="ri-building-line text-2xl text-teal-600"></i>
                </div>
                <div>
                  <h3 className="text-base font-semibold text-gray-900 mb-2">회사명</h3>
                  <p className="text-sm text-gray-600">{companyInfo.name}</p>
                </div>
              </div>

              <div className="flex items-start">
                <div className="w-12 h-12 bg-teal-100 rounded-lg flex items-center justify-center mr-4 flex-shrink-0">
                  <i className="ri-calendar-line text-2xl text-teal-600"></i>
                </div>
                <div>
                  <h3 className="text-base font-semibold text-gray-900 mb-2">설립연도</h3>
                  <p className="text-sm text-gray-600">{companyInfo.established}</p>
                </div>
              </div>

              <div className="flex items-start">
                <div className="w-12 h-12 bg-teal-100 rounded-lg flex items-center justify-center mr-4 flex-shrink-0">
                  <i className="ri-map-pin-line text-2xl text-teal-600"></i>
                </div>
                <div>
                  <h3 className="text-base font-semibold text-gray-900 mb-2">주소</h3>
                  <p className="text-sm text-gray-600">{companyInfo.address}</p>
                </div>
              </div>

              <div className="flex items-start">
                <div className="w-12 h-12 bg-teal-100 rounded-lg flex items-center justify-center mr-4 flex-shrink-0">
                  <i className="ri-phone-line text-2xl text-teal-600"></i>
                </div>
                <div>
                  <h3 className="text-base font-semibold text-gray-900 mb-2">연락처</h3>
                  <p className="text-sm text-gray-600">Tel: {companyInfo.phone}</p>
                  <p className="text-sm text-gray-600">Fax: {companyInfo.fax}</p>
                  <p className="text-sm text-gray-600">Email: {companyInfo.email}</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Business Areas */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">사업 영역</h2>
            <p className="text-lg text-gray-600">
              하천정비 및 침식방지 분야의 전문적인 솔루션을 제공합니다.
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
            {businessAreas.map((area, index) => (
              <div key={index} className="bg-gray-50 p-8 rounded-lg text-center hover:shadow-md transition-shadow">
                <div className="w-16 h-16 bg-teal-100 rounded-full flex items-center justify-center mx-auto mb-6">
                  <i className={`${area.icon} text-3xl text-teal-600`}></i>
                </div>
                <h3 className="text-lg font-bold text-gray-900 mb-3">{area.title}</h3>
                <p className="text-sm text-gray-600 leading-relaxed">{area.description}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Company Strengths */}
      <section className="py-20 bg-teal-600">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-3xl md:text-4xl font-bold text-white mb-4">회사 강점</h2>
            <p className="text-lg text-white/90">
              숫자로 증명하는 우진에코텍의 경쟁력
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            {companyStrengths.map((strength, index) => (
              <div key={index} className="bg-white/10 backdrop-blur-sm p-8 rounded-lg text-center">
                <div className="text-5xl md:text-6xl font-bold text-white mb-3">
                  {strength.number}
                </div>
                <h3 className="text-xl font-bold text-white mb-2">{strength.label}</h3>
                <p className="text-sm text-white/80">{strength.description}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Management Philosophy */}
      <section className="py-20 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">경영 방향</h2>
            <p className="text-lg text-gray-600">
              우진에코텍이 추구하는 핵심 가치
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            <div className="bg-white p-8 rounded-lg shadow-sm text-center">
              <div className="w-20 h-20 bg-teal-100 rounded-full flex items-center justify-center mx-auto mb-6">
                <i className="ri-shield-check-line text-4xl text-teal-600"></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-4">안전한 구조</h3>
              <p className="text-sm text-gray-600 leading-relaxed">
                구조적 안정성을 최우선으로 하여 장기적으로 안전한 하천정비 솔루션을 제공합니다.
              </p>
            </div>

            <div className="bg-white p-8 rounded-lg shadow-sm text-center">
              <div className="w-20 h-20 bg-teal-100 rounded-full flex items-center justify-center mx-auto mb-6">
                <i className="ri-medal-line text-4xl text-teal-600"></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-4">품질 중심</h3>
              <p className="text-sm text-gray-600 leading-relaxed">
                엄격한 품질관리 시스템을 통해 일관된 고품질 제품을 생산하고 공급합니다.
              </p>
            </div>

            <div className="bg-white p-8 rounded-lg shadow-sm text-center">
              <div className="w-20 h-20 bg-teal-100 rounded-full flex items-center justify-center mx-auto mb-6">
                <i className="ri-team-line text-4xl text-teal-600"></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-4">현장 중심</h3>
              <p className="text-sm text-gray-600 leading-relaxed">
                현장의 목소리에 귀 기울이며 실질적인 문제 해결에 집중합니다.
              </p>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}
